import { render, staticRenderFns } from "./UserDashboardAppointmentItem.vue?vue&type=template&id=d6663788&scoped=true&"
import script from "./UserDashboardAppointmentItem.vue?vue&type=script&lang=js&"
export * from "./UserDashboardAppointmentItem.vue?vue&type=script&lang=js&"
import style0 from "./UserDashboardAppointmentItem.vue?vue&type=style&index=0&id=d6663788&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6663788",
  null
  
)

export default component.exports